<div class="app-layout" [class.sidebar-closed]="!isSidebarOpen">
  <div class="sidebar-overlay" (click)="toggleSidebar()"></div>

  <aside class="sidebar">
    <div class="sidebar-header">
      <div class="logo-icon">K</div>
      <span class="logo-text">KCEG</span>
    </div>

    <nav class="sidebar-nav" *ngIf="{ profile: userProfile$ | async, perms: pagePermissions$ | async } as data">
      <div class="nav-group" *ngIf="activeSection === 'MAIN' || isMobile">
        <p class="group-title">MAIN</p>
        <a routerLink="dashboard" routerLinkActive="active" class="nav-link">
          <i class="icon">📊</i> <span>Dashboard</span>
        </a>
      </div>

      <div class="nav-group"
        *ngIf="(activeSection === 'INVOICE' || isMobile) && (canAccess('invoice', data.profile?.role, data.perms) || canAccess('sales-invoice', data.profile?.role, data.perms))">
        <p class="group-title">Invoice</p>
        <a *ngIf="canAccess('invoice', data.profile?.role, data.perms)" routerLink="invoice" routerLinkActive="active"
          class="nav-link">
          <i class="icon">📄</i> <span>SMRS Invoice</span>
        </a>
        <a *ngIf="canAccess('sales-invoice', data.profile?.role, data.perms)" routerLink="sales-invoice"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🧾</i> <span>Sales Invoice</span>
        </a>
      </div>

      <div class="nav-group"
        *ngIf="(activeSection === 'REPORTS' || isMobile) && (canAccess('profit-report', data.profile?.role, data.perms) || canAccess('daily-report', data.profile?.role, data.perms) || canAccess('smre-fee-report', data.profile?.role, data.perms) || canAccess('smrs-fee-report', data.profile?.role, data.perms) || canAccess('sales-report', data.profile?.role, data.perms) || canAccess('artist-statement', data.profile?.role, data.perms) || canAccess('frame-report', data.profile?.role, data.perms))">
        <p class="group-title">Reports</p>
        <a *ngIf="canAccess('profit-report', data.profile?.role, data.perms)" routerLink="profit-report"
          routerLinkActive="active" class="nav-link">
          <i class="icon">💰</i> <span>Profit Report</span>
        </a>
        <a *ngIf="canAccess('daily-report', data.profile?.role, data.perms)" routerLink="daily-report"
          routerLinkActive="active" class="nav-link">
          <i class="icon">📅</i> <span>Daily Report</span>
        </a>
        <a *ngIf="canAccess('frame-report', data.profile?.role, data.perms)" routerLink="frame-report"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🖼️</i> <span>Frame Report</span>
        </a>
        <a *ngIf="canAccess('smrs-fee-report', data.profile?.role, data.perms) || canAccess('smre-fee-report', data.profile?.role, data.perms)"
          routerLink="smrs-fee-report" routerLinkActive="active" class="nav-link">
          <i class="icon">🧾</i> <span>SMRS Fee Report</span>
        </a>
        <a *ngIf="canAccess('sales-report', data.profile?.role, data.perms)" routerLink="sales-report"
          routerLinkActive="active" class="nav-link">
          <i class="icon">💼</i> <span>Sales Report</span>
        </a>
        <a *ngIf="canAccess('artist-statement', data.profile?.role, data.perms)" routerLink="artist-statement"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🎤</i> <span>Artist Statement</span>
        </a>
      </div>

      <div class="nav-group" *ngIf="(activeSection === 'ADMIN' || isMobile) && (
        canAccess('accounts', data.profile?.role, data.perms) || 
        canAccess('company-management', data.profile?.role, data.perms) || 
        canAccess('owner-management', data.profile?.role, data.perms) || 
        canAccess('store-management', data.profile?.role, data.perms) || 
        canAccess('brand-management', data.profile?.role, data.perms) || 
        canAccess('dev-tool', data.profile?.role, data.perms) || 
        canAccess('access-control', data.profile?.role, data.perms) ||
        canAccess('smrs-rate-management', data.profile?.role, data.perms) ||
        canAccess('bank-management', data.profile?.role, data.perms) ||
        canAccess('agent-management', data.profile?.role, data.perms) || 
        canAccess('artist-management', data.profile?.role, data.perms) || 
        canAccess('coupon-management', data.profile?.role, data.perms) || 
        canAccess('refund-management', data.profile?.role, data.perms) || 
        canAccess('photobooth-management', data.profile?.role, data.perms) ||
        canAccess('konobox-management', data.profile?.role, data.perms))">
        <p class="group-title">ADMIN</p>
        <a *ngIf="canAccess('accounts', data.profile?.role, data.perms)" routerLink="accounts" routerLinkActive="active"
          class="nav-link">
          <i class="icon">🗂️</i> <span>Chart of Accounts</span>
        </a>
        <a *ngIf="canAccess('company-management', data.profile?.role, data.perms)" routerLink="company-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">👥</i> <span>Company Management</span>
        </a>
        <a *ngIf="canAccess('owner-management', data.profile?.role, data.perms)" routerLink="owner-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">👤</i> <span>Owner Management</span>
        </a>
        <a *ngIf="canAccess('store-management', data.profile?.role, data.perms)" routerLink="store-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🏪</i> <span>Store Management</span>
        </a>
        <a *ngIf="canAccess('brand-management', data.profile?.role, data.perms)" routerLink="brand-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🏷️</i> <span>Brand Management</span>
        </a>
        <a *ngIf="canAccess('photobooth-management', data.profile?.role, data.perms)" routerLink="photobooth-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">📸</i> <span>Photobooth Management</span>
        </a>
        <a *ngIf="canAccess('konobox-management', data.profile?.role, data.perms)" routerLink="konobox-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🎤</i> <span>Konobox Management</span>
        </a>
        <a *ngIf="canAccess('smrs-rate-management', data.profile?.role, data.perms)" routerLink="smrs-rate-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">⚙️</i> <span>SMRS Rate Management</span>
        </a>
        <a *ngIf="canAccess('bank-management', data.profile?.role, data.perms)" routerLink="bank-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🏦</i> <span>Bank Management</span>
        </a>
        <a *ngIf="canAccess('agent-management', data.profile?.role, data.perms)" routerLink="agent-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🤖</i> <span>Agent Management</span>
        </a>
        <a *ngIf="canAccess('artist-management', data.profile?.role, data.perms)" routerLink="artist-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🎤</i> <span>Artist Management</span>
        </a>
        <a *ngIf="canAccess('coupon-management', data.profile?.role, data.perms)" routerLink="coupon-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🎟️</i> <span>Coupon Management</span>
        </a>
        <a *ngIf="canAccess('refund-management', data.profile?.role, data.perms)" routerLink="refund-management"
          routerLinkActive="active" class="nav-link">
          <i class="icon">💳</i> <span>Refund Review Queue</span>
        </a>
        <a *ngIf="canAccess('dev-tool', data.profile?.role, data.perms)" routerLink="dev-tool" routerLinkActive="active"
          class="nav-link">
          <i class="icon">🛠️</i> <span>Developer Tools</span>
        </a>
        <a *ngIf="canAccess('access-control', data.profile?.role, data.perms)" routerLink="access-control"
          routerLinkActive="active" class="nav-link">
          <i class="icon">🛡️</i> <span>Access Control</span>
        </a>
      </div>
    </nav>

    <div class="sidebar-footer">
      <button (click)="logout()" class="logout-btn">
        <i class="icon">↪️</i> <span>Sign Out</span>
      </button>
    </div>
  </aside>

  <div class="main-wrapper">
    <ng-container *ngIf="{ profile: userProfile$ | async, perms: pagePermissions$ | async } as data">
      <header class="topbar">
        <div class="topbar-left">
          <button class="toggle-btn" (click)="toggleSidebar()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 12h18M3 6h18M3 18h18" />
            </svg>
          </button>
        </div>

        <nav class="top-nav">
          <div class="top-nav-item" [class.active]="activeSection === 'MAIN'">
            <a routerLink="dashboard" class="top-nav-link" (click)="activeSection = 'MAIN'">Main</a>
          </div>

          <div class="top-nav-item" [class.active]="activeSection === 'INVOICE'"
            *ngIf="canAccess('invoice', data.profile?.role, data.perms) || canAccess('sales-invoice', data.profile?.role, data.perms)">
            <span class="top-nav-link">
              Invoice
              <svg class="nav-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="dropdown-menu">
              <a *ngIf="canAccess('invoice', data.profile?.role, data.perms)" routerLink="invoice" class="dropdown-item"
                (click)="activeSection = 'INVOICE'">
                <span class="dropdown-icon">📄</span>
                <span>SMRS Invoice</span>
              </a>
              <a *ngIf="canAccess('sales-invoice', data.profile?.role, data.perms)" routerLink="sales-invoice"
                class="dropdown-item" (click)="activeSection = 'INVOICE'">
                <span class="dropdown-icon">🧾</span>
                <span>Sales Invoice</span>
              </a>
            </div>
          </div>

          <div class="top-nav-item" [class.active]="activeSection === 'REPORTS'"
            *ngIf="canAccess('profit-report', data.profile?.role, data.perms) || canAccess('daily-report', data.profile?.role, data.perms) || canAccess('smre-fee-report', data.profile?.role, data.perms) || canAccess('smrs-fee-report', data.profile?.role, data.perms) || canAccess('sales-report', data.profile?.role, data.perms) || canAccess('artist-statement', data.profile?.role, data.perms) || canAccess('frame-report', data.profile?.role, data.perms)">
            <span class="top-nav-link">
              Reports
              <svg class="nav-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="dropdown-menu">
              <a *ngIf="canAccess('profit-report', data.profile?.role, data.perms)" routerLink="profit-report"
                class="dropdown-item" (click)="activeSection = 'REPORTS'">
                <span class="dropdown-icon">💰</span>
                <span>Profit Report</span>
              </a>
              <a *ngIf="canAccess('daily-report', data.profile?.role, data.perms)" routerLink="daily-report"
                class="dropdown-item" (click)="activeSection = 'REPORTS'">
                <span class="dropdown-icon">📅</span>
                <span>Daily Report</span>
              </a>
              <a *ngIf="canAccess('frame-report', data.profile?.role, data.perms)" routerLink="frame-report"
                class="dropdown-item" (click)="activeSection = 'REPORTS'">
                <span class="dropdown-icon">🖼️</span>
                <span>Frame Report</span>
              </a>
              <a *ngIf="canAccess('smrs-fee-report', data.profile?.role, data.perms) || canAccess('smre-fee-report', data.profile?.role, data.perms)"
                routerLink="smrs-fee-report" class="dropdown-item" (click)="activeSection = 'REPORTS'">
                <span class="dropdown-icon">🧾</span>
                <span>SMRS Fee Report</span>
              </a>
              <a *ngIf="canAccess('sales-report', data.profile?.role, data.perms)" routerLink="sales-report"
                class="dropdown-item" (click)="activeSection = 'REPORTS'">
                <span class="dropdown-icon">💼</span>
                <span>Sales Report</span>
              </a>
              <a *ngIf="canAccess('artist-statement', data.profile?.role, data.perms)" routerLink="artist-statement"
                class="dropdown-item" (click)="activeSection = 'REPORTS'">
                <span class="dropdown-icon">🎤</span>
                <span>Artist Statement</span>
              </a>
            </div>
          </div>

          <div class="top-nav-item" [class.active]="activeSection === 'ADMIN'"
            *ngIf="canAccess('accounts', data.profile?.role, data.perms) || canAccess('company-management', data.profile?.role, data.perms) || canAccess('owner-management', data.profile?.role, data.perms) || canAccess('store-management', data.profile?.role, data.perms) || canAccess('brand-management', data.profile?.role, data.perms) || canAccess('dev-tool', data.profile?.role, data.perms) || canAccess('access-control', data.profile?.role, data.perms) || canAccess('bank-management', data.profile?.role, data.perms) || canAccess('agent-management', data.profile?.role, data.perms) || canAccess('artist-management', data.profile?.role, data.perms) || canAccess('smrs-rate-management', data.profile?.role, data.perms) || canAccess('coupon-management', data.profile?.role, data.perms) || canAccess('refund-management', data.profile?.role, data.perms) || canAccess('photobooth-management', data.profile?.role, data.perms) || canAccess('konobox-management', data.profile?.role, data.perms)">
            <span class="top-nav-link">
              Admin
              <svg class="nav-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="dropdown-menu">
              <a *ngIf="canAccess('accounts', data.profile?.role, data.perms)" routerLink="accounts"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🗂️</span>
                <span>Chart of Accounts</span>
              </a>
              <a *ngIf="canAccess('company-management', data.profile?.role, data.perms)" routerLink="company-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">👥</span>
                <span>Company Management</span>
              </a>
              <a *ngIf="canAccess('owner-management', data.profile?.role, data.perms)" routerLink="owner-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">👤</span>
                <span>Owner Management</span>
              </a>
              <a *ngIf="canAccess('store-management', data.profile?.role, data.perms)" routerLink="store-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🏪</span>
                <span>Store Management</span>
              </a>
              <a *ngIf="canAccess('brand-management', data.profile?.role, data.perms)" routerLink="brand-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🏷️</span>
                <span>Brand Management</span>
              </a>
              <a *ngIf="canAccess('photobooth-management', data.profile?.role, data.perms)"
                routerLink="photobooth-management" class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">📸</span>
                <span>Photobooth Management</span>
              </a>
              <a *ngIf="canAccess('konobox-management', data.profile?.role, data.perms)"
                routerLink="konobox-management" class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🎤</span>
                <span>Konobox Management</span>
              </a>
              <a *ngIf="canAccess('smrs-rate-management', data.profile?.role, data.perms)"
                routerLink="smrs-rate-management" class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">⚙️</span>
                <span>SMRS Rate Management</span>
              </a>
              <a *ngIf="canAccess('bank-management', data.profile?.role, data.perms)" routerLink="bank-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🏦</span>
                <span>Bank Management</span>
              </a>
              <a *ngIf="canAccess('agent-management', data.profile?.role, data.perms)" routerLink="agent-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🤖</span>
                <span>Agent Management</span>
              </a>
              <a *ngIf="canAccess('artist-management', data.profile?.role, data.perms)" routerLink="artist-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🎤</span>
                <span>Artist Management</span>
              </a>
              <a *ngIf="canAccess('coupon-management', data.profile?.role, data.perms)" routerLink="coupon-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🎟️</span>
                <span>Coupon Management</span>
              </a>
              <a *ngIf="canAccess('refund-management', data.profile?.role, data.perms)" routerLink="refund-management"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">💳</span>
                <span>Refund Review Queue</span>
              </a>
              <a *ngIf="canAccess('dev-tool', data.profile?.role, data.perms)" routerLink="dev-tool"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🛠️</span>
                <span>Developer Tools</span>
              </a>
              <a *ngIf="canAccess('access-control', data.profile?.role, data.perms)" routerLink="access-control"
                class="dropdown-item" (click)="activeSection = 'ADMIN'">
                <span class="dropdown-icon">🛡️</span>
                <span>Access Control</span>
              </a>
            </div>
          </div>
        </nav>

        <div class="topbar-right">
          <div class="top-nav-item brand-selector" *ngIf="!hideBrandSelector">
            <span class="top-nav-link">
              {{ selectedBrand?.name || 'Select Brand' }}
              <svg class="nav-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </span>
            <div class="dropdown-menu dropdown-menu-right">
              <a *ngFor="let brand of brands" class="dropdown-item" (click)="selectBrand(brand)">
                <span>{{ brand.name }}</span>
              </a>
            </div>
          </div>

          <div class="user-profile" *ngIf="user$ | async as user">
            <span class="user-name">{{ user.displayName }}</span>
            <img [src]="user.photoURL" class="avatar" alt="Profile">
          </div>
        </div>
      </header>
    </ng-container>

    <main class="content">
      <div class="loading-overlay" *ngIf="isLoading">
        <div class="spinner"></div>
      </div>
      <router-outlet></router-outlet>
    </main>

    <!-- Global AI Agent Assistant -->
    <ng-container *ngIf="{ profile: userProfile$ | async, perms: pagePermissions$ | async, roles: roles$ | async } as data">
      <app-agent-chat 
        *ngIf="canAccess('chat-agent', getRoleName(data.profile, data.roles), data.perms)"
        [userRole]="getRoleName(data.profile, data.roles)" 
        [permissions]="data.perms">
      </app-agent-chat>
    </ng-container>
  </div>
</div>